<template>
  <el-container class="height100">
    <el-row class="header-wrapper boxAll size12">

      <!--左侧导航-->
      <div :style="{width:width}" class="back05">
        <router-link to="/usUserInfo?id=UserCenterMenuItem" class="app XYcenter" :class="{'bbtLogo1':isMenuClose,'bbtLogo':!isMenuClose}">
          <svg class="icon" aria-hidden="true">
            <use v-show="isMenuClose" xlink:href="#iconlogo-" class=""></use>
            <use v-show="!isMenuClose" xlink:href="#iconlogo" class=""></use>
          </svg>
        </router-link>
        <li v-for="(child,index) in menuChildList" :key="index" class="colorF" v-if="perantMenuItemName == child.perantMenuItemName && (!child.permissionCode || profile.permissions.indexOf(child.permissionCode)!=-1)">
          <div :title="child.displayName" class="navLeftCont pointer"
               :class="{'moduleHoverIndex':moduleHoverIndex==child.name}" @click="openChildren(child.name,index)">
            <i class="iconfont size14 marRight5" :class="child.icon"></i>
            <span v-show="!isMenuClose">{{child.displayName}}</span>
            <i v-show="!isMenuClose" class="iconfont size12 floatR" :class="{'icon-xiangxia':moduleHoverIndex==child.name,'icon-jiantouyou':moduleHoverIndex!=child.name}"></i>
          </div>
          <el-collapse-transition >
            <div class="back04" v-if="moduleHoverIndex==child.name&& !isMenuClose">
              <div class="navLeftBox pointer" :class="{'hoverIndex':hoverIndex==childRen.name}"
                   v-for="(childRen,i) in child.childRen" :key="i" v-if="!childRen.permissionCode || profile.permissions.indexOf(childRen.permissionCode)!=-1"
                   @click="toRouter(childRen.name)">
                {{childRen.displayName}}
              </div>
            </div>
          </el-collapse-transition>
        </li>
      </div>



      <div class="flexCont">
        <!--顶部导航-->
        <ul class="chooseBox back04 color84 size12">
          <a class="XYcenter navLeftOpen pointer marRight15" @click="isMenuCloseFn">
            <svg class="icon" aria-hidden="true">
              <use v-show="!isMenuClose" xlink:href="#iconshouqi-"></use>
              <use v-show="isMenuClose" xlink:href="#iconzhankai-"></use>+

            </svg>
          </a>
          <div class="flexAlign nevatCont colorF" @click="handleSelect(submenu.name)"
               v-for="(submenu,index) in menuList"
               v-if="(submenu.name == 'BusinessManagement' && (profile.permissions.indexOf('Allow_VatServiceMenuItem')!=-1||profile.permissions.indexOf('Allow_TradeMarkServiceAdminMenuItem')!=-1)) || profile.permissions.indexOf(submenu.permissionCode)!=-1"
               :key="index" :index="submenu.name"
               :class="{'is-Titactive':perantMenuItemName == submenu.name}">
            {{submenu.displayName}}
          </div>
<!--          <div class="flexAlign nevatCont colorF" :class="{'is-Titactive':perantMenuItemName === 'distributionSystem'}" @click="handleSelect('distributionSystem')">分销系统</div>-->
          <!--右侧小菜单-->
          <el-row class="navTit colorF size12" type="flex" align="middle">
            <!--个人中心-->
            <el-dropdown trigger="hover" placement="bottom" @visible-change="personBoolFn" @command="personFn">
              <div class="el-dropdown-link flexAlign size12" style="height: 35px">
                <img src="../../assets/image/person_icon.png" slot="reference" @click="personFn('UserCenterMenuItem')"
                     class="pointer personImg marRight10">
                <span class="marLeft15 colorF" :title="tenantName">{{tenantName | ellipsisEight}}</span>
                <i class="iconfont size12 marLeft10 colorF"
                   :class="{'icon-xiangxia':!personBool,'icon-xiangxia-copy':personBool}"
                   style="margin-top: 5px;font-size: 12px;"></i>
              </div>
              <el-dropdown-menu slot="dropdown" class="userBoxTip color84 paddLeft10 paddRight10">
                <!--<el-dropdown-item command="UserCenterMenuItem" class="">{{tenantName}} <span class="colorG roleName"> {{roleName}}</span></el-dropdown-item>-->
                <!--<el-dropdown-item command="UserCenterMenuItem">用户中心</el-dropdown-item>-->
                <el-dropdown-item command="loginOut">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-row>

        </ul>
        <el-container class="boxAllCont backF">
          <!-- 路由匹配到的组件将渲染在这里 -->
          <router-view @hostStatus="localHost" @reload="reload" v-if="isRouterAlive"></router-view>
        </el-container>
      </div>

    </el-row>

  </el-container>
</template>

<script>
import Footer from "../commonModel/footer";
export default {
  components: {
    Footer
    // Titlenav
  },
  data() {
    return {
      isRouterAlive: true,
      personBool: false, //个人中心下拉默认隐藏
      profile: "",
      tenantName: "", //用户名字
      // visible2: false,
      showFn: location.href.indexOf("smERP") != -1 ? false : true,
      menuList: [
        {
          name: "PlatformCenter",
          displayName: "平台中心",
          permissionCode: "Allow_PlatformCenterMenuItem"
        },
        {
          name: "BusinessManagement",
          displayName: "税号注册和申报服务",
          permissionCode: "Allow_VatServiceMenuItem"
        },
        {
          name: "ComplianceServices",
          displayName: "合规服务",
          permissionCode: "Allow_VatServiceMenuItem"
        },
        {
          name: "InsuranceManagement",
          displayName: "保险服务",
          permissionCode: "Allow_InsuranceServiceMenuItem"
        },
        {
          name: "ContentsManagementMenuItem",
          displayName: "新闻/文档管理/通知管理",
          permissionCode: "Allow_ContentsManagementMenuItem"
        },
        // {"name":"developerCenter","displayName":"开发者中心","permissionCode":"Allow_DevServiceAdminMenuItem"},
        {
          name: "dataStatistics",
          displayName: "数据统计",
          permissionCode: "Allow_DataStatisticsMenuItem"
        },
        {
          name: "productService",
          displayName: "财务管理",
          permissionCode: "Allow_BusinessPurchaseOrderMenuItem"
        }
        // {"name":"trackingTrace","displayName":"轨迹追踪","permissionCode":"Allow_BusinessPurchaseOrderMenuItem"},
        // {"name":"TrademarkManagement","displayName":"商标注册服务","permissionCode":"Allow_TradeMarkServiceAdminMenuItem"},
      ],
      menuChildList: [
        {
          name: "UserCenterMenuItem",
          displayName: "用户中心",
          perantMenuItemName: "PlatformCenter",
          permissionCode: "Allow_UserCenterMenuItem",
          icon: "iconshouye",
          childRen: [
            {
              name: "UserCenterMenuItem",
              displayName: "基本资料",
              permissionCode: "Allow_UserProfileMenuItem"
            },
            {
              name: "UserAuthSettingMenuItem",
              displayName: "安全设置",
              permissionCode: "Allow_UserAuthSettingMenuItem"
            },
            {
              name: "UserAccountListMenuItem",
              displayName: "员工账号",
              permissionCode: "Allow_AdminUserAccountListMenuItem"
            },
            {
              name: "UserGroupListMenuItem",
              displayName: "员工分组",
              permissionCode: "Allow_AdminUserGroupListMenuItem"
            }
          ]
        },
        {
          name: "TenantManagementMenuItem",
          displayName: "客户管理",
          perantMenuItemName: "PlatformCenter",
          permissionCode: "Allow_TenantManagementMenuItem",
          icon: "iconkehu",
          childRen: [
            {
              name: "TenantManagementMenuItem",
              displayName: "客户列表",
              permissionCode: "Allow_TenantListMenuItem"
            },
            {
              name: "ImportedTenantListMenuItem",
              displayName: "VAT客户",
              permissionCode: "Allow_ImportedTenantListMenuItem"
            }
          ]
        },
        // vat服务 BusinessManagement
        {
          name: "VatHomeAdminMenuItem",
          displayName: "工作台",
          perantMenuItemName: "BusinessManagement",
          permissionCode: "",
          icon: "iconpingtai",
          childRen: [
            {
              name: "VatHomeAdminMenuItem",
              displayName: "首页看板",
              permissionCode: ""
            },
            {
              name: "VatUserListAdminMenuItem",
              displayName: "潜在客户",
              permissionCode: ""
            }
          ]
        },
        // crm服务 VatCrmUserListAdminMenuItem
        {
          name: "VatCrmUserListAdminMenuItem",
          displayName: "CRM管理",
          perantMenuItemName: "BusinessManagement",
          permissionCode: "",
          icon: "iconpingtai",
          childRen: [
            {
              name: "VatCrmUserListAdminMenuItem",
              displayName: "客户管理",
              permissionCode: ""
            },
            {
              name: "VatCrmChannelListAdminMenuItem",
              displayName: "渠道管理",
              permissionCode: ""
            },
            {
              name: "VatCrmServiceListAdminMenuItem",
              displayName: "服务协议",
              permissionCode: ""
            },
            {
              name: "VatCrmProjectListAdminMenuItem",
              displayName: "产品列表",
              permissionCode: ""
            },
            {
              name: "VatCrmAgentListAdminMenuItem",
              displayName: "代理资料",
              permissionCode: ""
            },
            {
              name: "VatCrmNewUserListAdminMenuItem",
              displayName: "客户管理(新)",
              permissionCode: ""
            },
            {
              name: "VatCrmNewServiceListAdminMenuItem",
              displayName: "服务协议(新)",
              permissionCode: ""
            },
            {
              name: "VatCrmProductOrderListAdminMenuItem",
              displayName: "产品订单",
              permissionCode: ""
            }
          ]
        },
        {
          name: "VatOrderMenuItem",
          displayName: "VAT订单管理",
          perantMenuItemName: "BusinessManagement",
          permissionCode: "Allow_VatServiceOrderMenuItem",
          icon: "icondingdanguanli",
          childRen: [
            {
              name: "VatOrderMenuItem",
              displayName: "税号订单",
              permissionCode: "Allow_VatServiceTaxOrderMenuItem"
            },
            {
              name: "MyVatOtherFunctionsAdminMenuItem",
              displayName: "其他服务订单",
              permissionCode: "Allow_VatServiceOtherOrderMenuItem"
            },
            {
              name: "VatDeclarationMenuItem",
              displayName: "申报记录",
              permissionCode: "Allow_VatServiceDeclareMenuItem"
            },
            {
              name: "VatLetterMenuItem",
              displayName: "信件管理",
              permissionCode: "Allow_VatServiceLetterMenuItem"
            },
            {
              name: "VatOfflineDataMenuItem",
              displayName: "线下操作管理",
              permissionCode: "Allow_VatOfflineDataMenuItem"
            }
          ]
        },
        {
          name: "VatIOSSOrderMenuItem",
          displayName: "IOSS订单管理",
          perantMenuItemName: "BusinessManagement",
          permissionCode: "Allow_VatServiceIOSSMenuItem",
          icon: "icondingdanguanli",
          childRen: [
            {
              name: "VatIOSSOrderMenuItem",
              displayName: "IOSS订单",
              permissionCode: "Allow_VatServiceIOSSOrderMenuItem"
            },
            {
              name: "VatIOSSDeclaredOrderMenuItem",
              displayName: "IOSS申报",
              permissionCode: "Allow_VatServiceDeclareMenuItem"
            },
            {
              name: "VatIOSSOfflineMenuItem",
              displayName: "线下操作管理",
              permissionCode: "Allow_VatOfflineDataMenuItem"
            }
          ]
        },
        {
          name: "VatNoMenuItem",
          displayName: "信息查看",
          perantMenuItemName: "BusinessManagement",
          permissionCode: "Allow_VatServiceInfomationMenuItem",
          icon: "iconjibenxinxi",
          childRen: [
            {
              name: "VatNoMenuItem",
              displayName: "税号管理",
              permissionCode: "Allow_VatServiceTaxNumberMenuItem"
            },
            {
              name: "VatHistoryMenuItem",
              displayName: "操作记录",
              permissionCode: "Allow_VatServiceOpLogMenuItem"
            }
          ]
        },
        {
          name: "VatCountryMenuItem",
          displayName: "税号业务管理",
          perantMenuItemName: "BusinessManagement",
          permissionCode: "Allow_VatServiceCountryMenuItem",
          icon: "iconyewushezhi",
          childRen: [
            {
              name: "VatCountryMenuItem",
              displayName: "税号业务管理",
              permissionCode: "Allow_VatServiceCountryBusMenuItem"
            },
            {
              name: "VatTaxMenuItem",
              displayName: "税代管理",
              permissionCode: "Allow_VatServiceTaxGenerationMenuItem"
            }
          ]
        },
        // 合规服务
        {
          name: "ComplianceAdminMenuItem",
          displayName: "合规服务管理",
          perantMenuItemName: "ComplianceServices",
          permissionCode: "Allow_InsuranceServiceMenuItem",
          icon: "iconshangbiao",
          childRen: [
            {
              name: "ComplianceAdminMenuItem",
              displayName: "欧代/英代管理",
              permissionCode: "Allow_PotentialTenantInsuranceServiceMenuItem"
            },
            {
              name: "EPRAdminMenuItem",
              displayName: "EPR注册管理",
              permissionCode: "Allow_PotentialTenantInsuranceServiceMenuItem"
            }
          ]
        },

        {
          name: "InsuranceUnUserListAdminMenuItem",
          displayName: "保险服务",
          perantMenuItemName: "InsuranceManagement",
          permissionCode: "Allow_InsuranceServiceMenuItem",
          icon: "iconshangbiao",
          childRen: [
            {
              name: "InsuranceUnUserListAdminMenuItem",
              displayName: "潜在客户",
              permissionCode: "Allow_PotentialTenantInsuranceServiceMenuItem"
            }
          ]
        },

        // {"name":"TradeMarkRegisterAdminMenuItem","displayName":"商标注册","perantMenuItemName":"TrademarkManagement","permissionCode":"Allow_TradeMarkServiceAdminMenuItem","icon":"iconshangbiao",
        //   "childRen":[
        //     {"name":"TradeMarkRegisterAdminMenuItem","displayName":"商标注册","permissionCode":"Allow_TradeMarkRegisterAdminMenuItem"},
        //     {"name":"TradeMarkRetrievalAdminMenuItem","displayName":"商标检索","permissionCode":"Allow_TradeMarkRetrievalAdminMenuItem"},
        //     {"name":"ArtWorksCopyrightAdminMenuItem","displayName":"美术版权登记","permissionCode":"Allow_ArtWorksCopyrightAdminMenuItem"},
        //     {"name":"SoftwareCopyrightAdminMenuItem","displayName":"计算软件著作登记","permissionCode":"Allow_SoftwareCopyrightAdminMenuItem"}
        //   ]
        // },

        {
          name: "NewsManagementMenuItem",
          displayName: "新闻管理",
          perantMenuItemName: "ContentsManagementMenuItem",
          permissionCode: "Allow_NewsManagementMenuItem",
          icon: "iconxinwenguanli",
          childRen: [
            {
              name: "NewsManagementMenuItem",
              displayName: "新闻列表",
              permissionCode: "Allow_NewsListMenuItem"
            },
            {
              name: "UpsertNewsOperator",
              displayName: "添加新闻",
              permissionCode: "Allow_UpsertNews"
            },
            {
              name: "NewsCategoryMenuItem",
              displayName: "新闻分类",
              permissionCode: "Allow_NewsCategoryMenuItem"
            }
            // {"name":"4","displayName":"搜索标签管理","permissionCode":""}
          ]
        },
        {
          name: "BannerMenuItem",
          displayName: "广告管理",
          perantMenuItemName: "ContentsManagementMenuItem",
          permissionCode: "Allow_NewsManagementMenuItem",
          icon: "iconhuodong1",
          childRen: [
            {
              name: "BannerMenuItem",
              displayName: "广告图列表",
              permissionCode: "Allow_NewsManagementMenuItem"
            }
            // {"name":"SystemMessageMenuItem","displayName":"系统消息","permissionCode":"Allow_SystemMessageMenuItem"},
          ]
        },
        {
          name: "ManualManagementMenuItem",
          displayName: "文档中心管理",
          perantMenuItemName: "ContentsManagementMenuItem",
          permissionCode: "Allow_ManualManagementMenuItem",
          icon: "iconwendangzhongxin",
          childRen: [
            {
              name: "ManualManagementMenuItem",
              displayName: "文档列表",
              permissionCode: "Allow_ManualListMenuItem"
            },
            {
              name: "UpsertManualOperator",
              displayName: "添加文档",
              permissionCode: "Allow_UpsertManual"
            },
            {
              name: "ManualCategoryMenuItem",
              displayName: "文档分类",
              permissionCode: "Allow_ManualCategoryMenuItem"
            }
            // {"name":"44","displayName":"搜索标签管理","permissionCode":""}
          ]
        },
        {
          name: "NotiManagementMenuItem",
          displayName: "消息通知管理",
          perantMenuItemName: "ContentsManagementMenuItem",
          permissionCode: "Allow_NotiManagementMenuItem",
          icon: "iconxiaoxi",
          childRen: [
            {
              name: "NotiManagementMenuItem",
              displayName: "人工通知",
              permissionCode: "Allow_ManualNotiManagementMenuItem"
            }
            // {"name":"SystemMessageMenuItem","displayName":"系统消息","permissionCode":"Allow_SystemMessageMenuItem"},
          ]
        },

        // {"name":"businessMenuItem","displayName":"开发者中心","perantMenuItemName":"developerCenter","permissionCode":"Allow_DevServiceAdminMenuItem","icon":"iconxinwenguanli",
        //   "childRen":[
        //     {"name":"businessMenuItem","displayName":"企业信息","permissionCode":"Allow_DevEnterpriseAdminMenuItem"},
        //     {"name":"appListMenuItem","displayName":"应用列表","permissionCode":"Allow_DevAppAdminMenuItem"},
        //     {"name":"developerListMenuItem","displayName":"开发者列表","permissionCode":"Allow_DevUserAdminMenuItem"},
        //     {"name":"editDeveloperDocMenuItem","displayName":"发布文档","permissionCode":"Allow_DevUserAdminMenuItem"},
        //     {"name":"developerDocTypeMenuItem","displayName":"文档分类","permissionCode":"Allow_DevUserAdminMenuItem"},
        //   ]
        // },

        {
          name: "userStatistics",
          displayName: "用户使用统计",
          perantMenuItemName: "dataStatistics",
          permissionCode: "Allow_FunctionUseageDataStatisticsMenuItem",
          icon: "icongongnengtongji",
          childRen: [
            {
              name: "userStatistics",
              displayName: "用户统计",
              permissionCode: "Allow_DataStatisticsForCustomerMenuItem"
            },
            {
              name: "userVATBusinessStatistics",
              displayName: "用户VAT业务统计",
              permissionCode: "Allow_DataStatisticsForVatMenuItem"
            },
            // {"name":"userTrademarkBusinessStatistics","displayName":"用户商标业务统计","permissionCode":"Allow_BusinessPlatformShopStatisticsMenuItem"},
            {
              name: "userTrackingServiceStatistics",
              displayName: "用户轨迹服务统计",
              permissionCode: "Allow_DataStatisticsForTyMenuItem"
            },
            {
              name: "userERPServiceStatistics",
              displayName: "用户ERP服务统计",
              permissionCode: "Allow_DataStatisticsForErpMenuItem"
            },
            {
              name: "storeCenterAuthorization",
              displayName: "店铺中心授权",
              permissionCode: "Allow_DataStatisticsForPlatformShopMenuItem"
            }
          ]
        }, // 用户消费行为分析
        {
          name: "customerSpendingBehavior",
          displayName: "用户分析",
          perantMenuItemName: "dataStatistics",
          permissionCode: "Allow_CustomerBehaviorStatisticsMenuItem",
          icon: "iconyonghuguanli",
          childRen: [
            {
              name: "customerSpendingBehavior",
              displayName: "用户使用行为分析",
              permissionCode:
                "Allow_CustomerBehaviorForUseageStatisticsMenuItem"
            }
          ]
        },
        {
          name: "trajectoryService",
          displayName: "产品使用统计",
          perantMenuItemName: "dataStatistics",
          permissionCode: "Allow_ProductUseageDataStatisticsMenuItem",
          icon: "iconchanpintongji",
          childRen: [
            {
              name: "trajectoryService",
              displayName: "功能使用统计",
              permissionCode: "Allow_DataStatisticsForProductFunctionMenuItem"
            }
          ]
        },
        {
          name: "trajectoryDataAnalysis",
          displayName: "轨迹数据分析",
          perantMenuItemName: "dataStatistics",
          permissionCode: "Allow_ProductUseageDataStatisticsMenuItem",
          icon: "iconchanpintongji",
          childRen: [
            {
              name: "trajectoryDataAnalysis",
              displayName: "上网/妥投分布",
              permissionCode: "Allow_DataStatisticsForProductFunctionMenuItem"
            }
          ]
        },
        {
          name: "purchaselist",
          displayName: "账务管理",
          perantMenuItemName: "productService",
          permissionCode: "Allow_BusinessPurchaseOrderMenuItem",
          icon: "iconxinwenguanli",
          childRen: [
            {
              name: "purchaselist",
              displayName: "收款",
              permissionCode: "Allow_BusinessPurchaseOrderListMenuItem"
            },
            {
              name: "refundlist",
              displayName: "支出",
              permissionCode: "Allow_BusinessPurchaseOrderListMenuItem"
            },
            {
              name: "appRover",
              displayName: "审批人配置",
              permissionCode: "Allow_BusinessPurchaseOrderListMenuItem"
            }
          ]
        },
        {
          name: "packageManagement",
          displayName: "产品服务管理",
          perantMenuItemName: "productService",
          permissionCode: "Allow_BusinessPricingProductMenuItem",
          icon: "iconxinwenguanli",
          childRen: [
            {
              name: "packageManagement",
              displayName: "套餐管理",
              permissionCode: "Allow_BusinessComboPricingProductListMenuItem"
            },
            {
              name: "productManagement",
              displayName: "产品管理",
              permissionCode: "Allow_BusinessPricingProductListMenuItem"
            }
          ]
        },
        {
          name: "sysRevise",
          displayName: "系统订单管理",
          perantMenuItemName: "productService",
          permissionCode: "Allow_TaxPurchaseOrderListMenuItem",
          icon: "iconshuihaofuwu",
          childRen: [
            {
              name: "sysRevise",
              displayName: "订单修订管理",
              permissionCode: "Allow_TaxPurchaseOrderListMenuItem"
            }
          ]
        },
        {
          name: "vatProductBuy",
          displayName: "税号产品服务购买",
          perantMenuItemName: "productService",
          permissionCode: "Allow_TaxPurchaseOrderListMenuItem",
          icon: "iconshuihaofuwu",
          childRen: [
            {
              name: "vatProductBuy",
              displayName: "购买管理",
              permissionCode: "Allow_TaxPurchaseOrderListMenuItem"
            },
            {
              name: "productBack",
              displayName: "退款管理",
              permissionCode: "Allow_TaxPurchaseOrderRefundMenuItem"
            },
            {
              name: "invoiceManage",
              displayName: "发票管理",
              permissionCode: "Allow_TaxInvoiceMenuItem"
            }
          ]
        },
        {
          name: "vatProductManagement",
          displayName: "税号产品服务管理",
          perantMenuItemName: "productService",
          permissionCode: "Allow_TaxProductListMenuItem",
          icon: "iconfuwuguanli1",
          childRen: [
            {
              name: "vatProductManagement",
              displayName: "产品管理",
              permissionCode: "Allow_TaxProductListMenuItem"
            }
          ]
        },
        {
          name: "renewTip",
          displayName: "续费提醒",
          perantMenuItemName: "productService",
          permissionCode: "Allow_TaxRenewListMenuItem",
          icon: "iconxufei",
          childRen: [
            {
              name: "renewTip",
              displayName: "续费提醒",
              permissionCode: "Allow_TaxRenewListMenuItem"
            }
          ]
        },
        {
          name: "trackingAnalysis",
          displayName: "物流轨迹分析配置",
          perantMenuItemName: "trackingTrace",
          permissionCode: "Allow_BusinessPricingProductMenuItem",
          icon: "iconxinwenguanli",
          childRen: [
            {
              name: "trackingAnalysis",
              displayName: "物流轨迹分析配置",
              permissionCode: "Allow_BusinessComboPricingProductListMenuItem"
            },
            {
              name: "trackingChase",
              displayName: "物流轨迹追踪配置",
              permissionCode: "Allow_BusinessComboPricingProductListMenuItem"
            }
          ]
        },
        {
          name: "trackingYeeQueryWaybill",
          displayName: "运单查询管理",
          perantMenuItemName: "trackingTrace",
          permissionCode: "Allow_BusinessComboPricingProductListMenuItem",
          icon: "iconyundanguanli",
          childRen: [
            {
              name: "trackingYeeQueryWaybill",
              displayName: "运单查询列表",
              permissionCode: "Allow_BusinessComboPricingProductListMenuItem"
            }
          ]
        }

        // 分销系统
        // {"name":"channelManagement","displayName":"渠道管理","perantMenuItemName":"distributionSystem","permissionCode":"Allow_UserCenterMenuItem","icon":"iconqudao",
        // },
        // {"name":"userManagement","displayName":"用户管理","perantMenuItemName":"distributionSystem","permissionCode":"Allow_UserCenterMenuItem","icon":"iconyonghu1",
        // },
        // {"name":"fundDetails","displayName":"资金明细","perantMenuItemName":"distributionSystem","permissionCode":"Allow_UserCenterMenuItem","icon":"iconzijin",
        // },
        // {"name":"orderDetails","displayName":"订单明细","perantMenuItemName":"distributionSystem","permissionCode":"Allow_UserCenterMenuItem","icon":"icondingdan",
        // },

        //商标注册
        // {"name":"channelManagement","displayName":"商标注册","perantMenuItemName":"trademarkSystem","permissionCode":"Allow_UserCenterMenuItem","icon":"iconqudao",
        // },
      ], //所有子集菜单
      menuChildListBool: [false, false, false, false, false, false],
      perantMenuItemName: "PlatformCenter", //父级所属模块
      moduleHoverIndex: "UserCenterMenuItem",
      hoverIndex: "UserCenterMenuItem",

      // menuitems:"",//不同父级的菜单

      // activeIndex: 'ProductAndServceMenuItem',//顶部用户选项
      // defaultActiveMenu: '',//父级用户选项
      width: "210px", //左侧导航栏宽度
      iconLeft: "27px",
      isMenuClose: false,
      clientHeight: document.documentElement.clientHeight - 114,
      // titNavNum:[{name:"产品与服务",token:"1-1"},{name:"用户中心",token:"2-1"},{name:"账户中心",token:"3-1"},{name:"通用设置",token:"4-1"},{name:"工单系统",token:"5-1"},{name:"+绑定店铺",token:"6-1"}],//父→子传值
      lang: "en",
      options2: [
        {
          value: "cn",
          label: "中文"
        }
      ],
      value2: ""
    };
  },
  mounted() {},
  filters: {
    ellipsisEight: function(value) {
      if (!value) return "";
      if (escape(value).indexOf("%u") < 0) {
        if (value.length > 16) {
          return value.substring(0, 15) + "...";
        } else {
          return value;
        }
      } else {
        if (value.length > 8) {
          return value.substring(0, 8) + "...";
        } else {
          return value;
        }
      }
    }
  },
  created() {
    // console.log(localStorage["profile"], 'localStorage["profile"]');
    this.profile = localStorage["profile"]
      ? JSON.parse(localStorage["profile"])
      : "";
    if (!this.profile) {
      this.$http.getApi(this.saasApi.permissions, "GET", "", data => {
        localStorage["profile"] = data;
        this.profile = JSON.parse(data);
      });
    }
    this.getProfile(); //获取用户资料
    // this.handleSelect('PlatformCenter');
    // this.getMenu(data=>{
    //   // this.handleSelect(data[0].name);
    // });
    // if(localStorage['menuitems']){
    //   this.menuitems = JSON.parse(localStorage['menuitems']);//顶部菜单
    //
    // }else{
    //   this.handleSelect('PlatformCenter');
    // }

    // this.perantMenuItemName = localStorage['perantMenuItemName']?localStorage['perantMenuItemName']:"PlatformCenter";//顶部菜单筛选值
    // this.moduleHoverIndex = localStorage["moduleHoverIndex"]?localStorage['moduleHoverIndex']:"UserCenterMenuItem";//顶部当前选项
    // this.hoverIndex = localStorage["hoverIndex"]?localStorage['hoverIndex']:"UserCenterMenuItem";//左侧当前选项

    // // 点击三级
    // this.toRouter(this.hoverIndex)
    const { path, meta, query } = this.$route;
    this.perantMenuItemName = meta.perantMenuItemName; //顶部菜单筛选值
    this.moduleHoverIndex = meta.moduleHoverIndex; //顶部当前选项
    if (path === "/usUserInfo") {
      this.hoverIndex = query.id;
    } else {
      this.hoverIndex = meta.hoverIndex; //左侧当前选项
    }
  },
  methods: {
    // 父级重新加载路由
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    // handleOpen(key, keyPath) {
    // },
    // handleClose(key, keyPath) {
    // },
    // 个人中心下拉显示隐藏
    personBoolFn(value) {
      this.personBool = value;
    },
    // 个人中心点击下拉选项
    personFn(name) {
      if (name == "UserCenterMenuItem") {
        this.handleSelect("PlatformCenter");
      } else if (name == "loginOut") {
        this.loginOut(name);
      }
    },
    // 路由传参
    localHost(data) {
      // alert(data)
      // if(data === 'VatRegisterMenuItem'){
      //   this.activeIndex = data
      // }else{
      //   this.handleSelect(data,'0')
      // }
    },
    // iconImgFn(value){
    //   if(!value) return false;
    //   return `${process.env.FILE_SERVICE}/${value}`;
    // },
    // 切换语言
    command(value) {
      this.$i18n.locale = value;
    },
    // 获取产品模块
    // getMenu(callBack){
    //   this.$http.getApi(this.saasApi.ServiceModules,'GET','',(data)=>{
    //     this.menuList = JSON.parse(data);
    //     callBack(JSON.parse(data))
    //   });
    //
    // },
    // 点击调用VAT项目的方法（测试——后期删除）
    loginOut() {
      this.$http.loginOut();
    },
    loginIn() {
      this.$http.login();
    },
    getProfile() {
      this.$http.getApi(this.saasApi.profile, "GET", "", data => {
        let res = JSON.parse(data);
        this.tenantName = res.fullName;
        localStorage["user"] = data;
      });
    },

    // 点击收缩
    isMenuCloseFn() {
      if (this.isMenuClose) {
        this.width = "210px";
        this.iconLeft = "27px";
      } else {
        this.width = "48px";
        this.iconLeft = "17px";
      }
      this.isMenuClose = !this.isMenuClose;
    },

    // 消息通知
    // tips(){
    //   this.onMenuClick(1,"tips")
    // },
    // getMenuitems(name,callback){
    //   this.$http.getApi(this.saasApi.menuitemsStart+name+this.saasApi.menuitemsEnd,'GET','',(data)=> {
    //     callback(JSON.parse(data));
    //   })
    // },
    // 点击一级
    handleSelect(name) {
      if (this.isMenuClose) {
        this.isMenuClose = false;
        this.width = "210px";
      }
      this.perantMenuItemName = name;
      localStorage["perantMenuItemName"] = name;

      if (name === "PlatformCenter") {
        this.openChildren("UserCenterMenuItem");
        // this.$set(this.menuChildListBool,0,true)
      } else if (name === "BusinessManagement") {
        this.openChildren("VatHomeAdminMenuItem");
        // this.$set(this.menuChildListBool,2,true)
      } else if (name === "ComplianceServices") {
        this.openChildren("ComplianceAdminMenuItem");
      } else if (name === "InsuranceManagement") {
        this.openChildren("InsuranceUnUserListAdminMenuItem");
      } else if (name === "TrademarkManagement") {
        this.openChildren("TradeMarkRegisterAdminMenuItem");
        // this.$set(this.menuChildListBool,2,true)
      } else if (name === "ContentsManagementMenuItem") {
        this.openChildren("NewsManagementMenuItem");
        // this.$set(this.menuChildListBool,4,true)
      } else if (name === "developerCenter") {
        this.openChildren("businessMenuItem");
        // this.$set(this.menuChildListBool,4,true)
      } else if (name === "dataStatistics") {
        this.openChildren("storeCenterAuthorization");
        // this.$set(this.menuChildListBool,4,true)
      } else if (name === "productService") {
        this.openChildren("purchaselist");
        // this.$set(this.menuChildListBool,4,true)
      } else if (name === "trackingTrace") {
        this.openChildren("trackingAnalysis");
      } else if (name === "distributionSystem") {
        this.openChildren("distributionSystem");
      }
    },
    // 点击二级
    openChildren(name) {
      // debugger
      this.moduleHoverIndex = name;
      // this.menuChildListBool.forEach((t,index)=>{
      //   if(index!=num) {
      //     this.$set(this.menuChildListBool,index,false)
      //   }
      // })
      // this.$set(this.menuChildListBool,num,!this.menuChildListBool[num])
      this.toRouter(name);
    },
    // 点击三级
    toRouter(name) {
      this.hoverIndex = name;

      if (
        name == "UserCenterMenuItem" ||
        name == "UserAuthSettingMenuItem" ||
        name == "UserAccountListMenuItem" ||
        name == "UserGroupListMenuItem"
      ) {
        this.commonJs.clickTitNav("UserCenterMenuItem", name);
      } else {
        this.commonJs.clickTitNav(name);
      }
    }
    // handleSelect(name,num) {
    //   this.width = '215px';
    //   this.iconLeft='27px';
    //   this.isMenuClose = false;
    //   this.$http.getApi(this.saasApi.menuitemsStart+name+this.saasApi.menuitemsEnd,'GET','',(data)=>{
    //     this.menuitems = JSON.parse(data);
    //
    //     this.defaultActiveMenu = name;
    //     if(name == 'PlatformCenter'&&num!=0){
    //       this.perantMenuItemName = name+'MenuItem';
    //       this.activeIndex = 'UserCenterMenuItem';
    //       this.handleSelect1("UserCenterMenuItem");
    //       this.$router.push({path: "/vsUs/UserCenterMenuItem"})
    //     }else if(name == 'VatService'&&num!=0){
    //       this.perantMenuItemName = name+'AdminMenuItem';
    //       this.activeIndex = 'VatHomeAdminMenuItem';
    //       this.handleSelect1("VatHomeAdminMenuItem");
    //       // this.$router.push({path: "/vatApply"})
    //     }else if(name == 'TradeMarkService'&&num!=0){
    //       this.perantMenuItemName = name+'AdminMenuItem';
    //       this.activeIndex = 'TradeMarkRegisterAdminMenuItem';
    //       this.handleSelect1("TradeMarkRegisterAdminMenuItem");
    //       // this.$router.push({path: "/vatApply"})
    //     }else if(name == 'SumyERP'){
    //       this.$message('正在开发中，敬请期待。。。');
    //     }else if(name == 'TrackingService'){
    //       this.$message('正在开发中，敬请期待。。。');
    //     }else if(name == 'ProductLibraryService'){
    //       this.$message('正在开发中，敬请期待。。。');
    //     }
    //     localStorage["menuitems"] = data;
    //     localStorage["defaultActiveMenu"] = name;//左侧一级选项
    //     localStorage["perantMenuItemName"] = name+'MenuItem';
    //     // this.$router.push({path:`/home`})
    //   });
    //   // localStorage["perantMenuItemName"] = name+'MenuItem';
    //
    // },
    // handleSelect1(key) {
    //   localStorage["titOption"] = key;
    //   this.activeIndex = key;
    //   // this.$forceUpdate ()//页面加载没有渲染，强制渲染
    //   this.commonJs.clickTitNav(key);
    // },
  },
  beforeRouteUpdate(to, from, next) {
    const { meta, query } = to;
    this.perantMenuItemName = meta.perantMenuItemName; //顶部菜单筛选值
    this.moduleHoverIndex = meta.moduleHoverIndex; //顶部当前选项
    if (to.path === "/usUserInfo") {
      this.hoverIndex = query.id;
    } else {
      this.hoverIndex = meta.hoverIndex; //左侧当前选项
    }
    next();
  }
};
</script>

<style scoped>
.bbtLogo {
  width: 160px;
  height: 40px;
  margin: 25px;
  overflow: hidden;
}
.bbtLogo1 {
  width: 34px;
  height: 40px;
  margin: 25px 8px;
  overflow: hidden;
}

.flexCont {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.marRight5 {
  margin-right: 5px;
}
.navLeftCont {
  padding: 15px 10px 15px 20px;
}
.navLeftBox {
  padding: 8px 0px 8px 27px;
}
.floatR {
  float: right;
}

.moduleHoverIndex {
  background: #289efc;
  color: #fff;
}
.navLeftCont:hover {
  background: #289efc;
  color: #fff;
}
.hoverIndex {
  color: #fecf4e;
}
.navLeftBox:hover {
  color: #fecf4e;
}
.navLeftBox:hover .navLeftBox::before {
  background: #fecf4e;
}

.navLeftBox::before {
  content: "";
  background: none;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: relative;
  left: 0;
  top: -2px;
  margin-right: 5px;
  display: inline-block;
}

.hoverIndex::before {
  background: #fecf4e;
}
.flexAlign {
  display: flex;
  align-items: center;
}

.navLeftOpen {
  width: 22px;
  height: 16px;
}

.navTit {
  height: 46px;
  padding-right: 20px;
  flex: 1;
  justify-content: flex-end;
}

.personImg {
  width: 30px;
  border-radius: 50%;
  height: 30px;
}

.searchAll /deep/ .el-input__inner {
  width: 100%;
  height: 22px;
  border-radius: 44px;
  padding: 0;
  border: none;
}

.searchAll {
  height: 22px;
  border-radius: 44px;
  width: 0px;
  transition: width 0.2s ease-out;
  margin-right: 10px;
}

.searchAllOpen {
  width: 300px;
  transition: width 0.2s ease-in;
}

.searchAllOpen /deep/ .el-input__inner {
  padding-left: 12px;
}

.chooseBox {
  width: 100%;
  height: 55px;
  display: flex;
  border-bottom: none;
  align-items: center;
  position: relative;
  padding: 0 30px 0 15px;
  box-sizing: border-box;
}

.chooseBox .el-menu-item {
  padding: 0 !important;
  height: 55px;
  line-height: 55px;
}

.nevatCont {
  cursor: pointer;
  text-align: center;
  line-height: 52px;
  padding: 0 10px;
  margin: 0 10px;
  border-bottom: 2px solid rgb(55, 55, 55);
}

.nevatCont:hover {
  color: rgb(255, 208, 75) !important;
  border-bottom-color: rgb(255, 208, 75) !important;
}

.is-Titactive {
  color: rgb(255, 208, 75) !important;
  border-bottom-color: rgb(255, 208, 75) !important;
}

.wrapper /deep/ .el-menu-item {
  height: 55px;
  line-height: 55px;
}

/*个人中心弹窗*/
.personBox div {
  cursor: pointer;
  padding: 15px;
  position: relative;
}

.el-menu-item i {
  color: #fff;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom-color: rgb(55, 55, 55);
}
</style>



// WEBPACK FOOTER //
// src/components/basics/navigation.vue